<template>
  <v-container grid-list-md pa-0 class='playlist'>
    <transition name='fade'>
      <div
        class='playlist-header mb-5'
        v-if='playlist.internalImageLarge'
        :style="'background: url('+playlist.internalImageLarge+') no-repeat 50% 50%'"
      ></div>
    </transition>

    <v-layout row wrap>
      <v-flex xs12 lg12 pl-4 pr-4 class='backgroundVFlex white--text'>
        <h1 class='display-1 headline mb-2 mt-2' v-html='playlist.description'></h1>

        <div class='playlist-chips mb-2'>
          <span
            class='item'
            v-if='parseInt(issues.length) === 1'
          >{{ issues.length }} {{ $t('text.Edition') }}</span>
          <span class='item' v-else>{{ issues.length }} {{ $t('text.Editions') }}</span>
        </div>
      </v-flex>

      <v-layout class='flex xs12 relative wrapper-loading mt-4 pl-4 pr-4'>
        <transition-group name='fade' tag='v-layout' class='xs12 row wrap'>
          <card-issue
            v-for='item in issues'
            :key='`slide-playlist-${item.id}`'
            :id='item.id'
            :issue='item'
            :isFree='item.isFree'
            :img='item.cover'
            :title='item.title.name'
            :subtitle="'Volume ' + item.number"
          ></card-issue>
        </transition-group>

        <transition name='fade'>
          <v-flex xs12 mb-4 v-if='loaded == true && issues.length == 0'>
            <v-alert :value='true' type='warning'>Playlist não encontrada ou indisponível no momento.</v-alert>
          </v-flex>
        </transition>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios';
import bus from '@/utils/bus';
import loading from '@/components/Loading';
import cardIssue from '@/components/cardIssue';

export default {
  name: 'playlist',
  components: {
    loading,
    'card-issue': cardIssue
  },
  metaInfo() {
    return {
      title: this.$route.meta.title
        ? 'Super Comics - ' + this.$t(this.$route.meta.title)
        : 'Super Comics'
    };
  },
  data() {
    return {
      loaded: false,
      errors: [],
      issues: [],
      playlist: {}
    };
  },
  mounted() {
    bus.$emit('loading', true);
    this.getIssues(this.$route.meta.type, this.$route.params.playlistId);
  },
  methods: {
    async getIssues(type, playlistId) {
      try {
        const urls = {
          Popular: '/api/issues/weeklyTop',
          Recomended: '/api/issues/recommended',
          News: '/api/issues/news',
          Playlist: `/playlists/${playlistId}`,
          Download: `/api/issues/downloads`
        };

        const response = await axios.get(urls[type], { params: { limit: 21, page: 1 } });

        if (type === 'Playlist') {
          this.playlist = response.data;
          this.issues = response.data.issues;
        } else {
          this.issues = response.data.results;
        }

        this.loaded = true;

        this.$store.commit(
          'setSubscription',
          response.headers['active-subscription']
        );
      } catch (e) {
        this.errors.push(e);
        this.loaded = true;
      } finally {
        bus.$emit('loading', false);
      }
    }
  }
};
</script>

<style lang='scss'>
@import '../assets/css/_variables';

.playlist {
  &-header {
    height: auto;
    overflow: hidden;
    width: 100%;
    background-size: contain !important;
    padding-bottom: 53%;
  }

  &-chips {
    font-size: 14px;

    .item {
      margin-right: 15px;
    }

    .v-hip {
      border-radius: 5px;
      font-size: 14px;
      top: -1px;

      .v-chip__content {
        height: 22px;
        padding: 0 8px;
      }
    }
  }
}

.backgroundVFlex {
  background: linear-gradient(
      145deg,
      rgba(52, 38, 94, 1) 0%,
      rgba(18, 17, 32, 1) 100%
  );
}
</style>
